import errorTypes from '../constants/errorTypes';
import validationRules from '../constants/validationRules';

export function validateName(name) {
  if (name === '') {
    return errorTypes.FIELD_REQUIRED;
  } if (!/[a-zA-Z]/.test(name)) {
    return errorTypes.NAME_ONLY_NON_NUMERIC;
  } if (name.length < validationRules.NAME_LENGTH_MIN
    || name.length > validationRules.NAME_LENGTH_MAX) {
    return errorTypes.NAME_CHAR_LIMIT;
  }
  return null;
}

function trimName(name, length) {
  return name.substring(0, length);
}

export function trimCompanyName(companyName) {
  return trimName(companyName, validationRules.COMPANY_NAME_MAX);
}

export function validateCompanyName(companyName) {
  if (companyName === '') {
    return errorTypes.FIELD_REQUIRED;
  }
  return null;
}

export function validPhoneNumber(phoneNumber) {
  const trimmedPhone = phoneNumber.trim();
  return trimmedPhone.replace(/\D/g, '');
}

export function validatePhoneNumber(phoneNumber) {
  if (phoneNumber === '') {
    return null; // empty values are a-ok
  } if (phoneNumber.length < validationRules.PHONE_LENGTH_MIN
    || phoneNumber.length > validationRules.PHONE_LENGTH_MAX) {
    return errorTypes.PHONE_CHAR_LIMIT;
  }
  return null;
}

export function trimWebsite(website) {
  return trimName(website, validationRules.WEBSITE_LENGTH_MAX);
}

export function validateWebsite(website) {
  if (website === '') {
    return errorTypes.FIELD_REQUIRED;
  }

  return null;
}
